module.exports = __webpack_public_path__ + "img/silo.aaadba15.svg";